export default __webpack_public_path__ + "static/media/Mystical-Menagerie-Logo.80269fa9.webp";